import { CosmosButton, CosmosCheckbox, CosmosIconDelete, CosmosIconPen, CosmosText } from "@cosmos/web/react"
import Loading from "../loading/loading"
import moment from "moment"

// Returns the markup and functionality for the guest rows
export default function GuestRow({
	id,
	name,
	group,
	checked_in,
	check_in_available,
	pin,
	toggleCheckIn,
	loading,
	redeemed,
	redeemedAt,
	deleteFromEvent,
	deleting,
	tour_name,
	tour_start,
	tour_guide,
	editGuest,
}) {
	const tour_names = tour_name?.split(",").map((tour) => tour.trim())
	const tour_guides = tour_guide?.split(",").map((guide) => guide.trim())
	const tour_starts = tour_start?.split(",").map((start) => start.trim())

	return (
		<div
			className={["thosp-guest-row", check_in_available ? "check-in-available" : ""].join(" ").trim()}
			data-guest-id={id}>
			<div className="guest-row-name">
				<CosmosText
					appearance="light"
					size="small">
					<strong>{name.trim()}</strong>, {group}
				</CosmosText>

				{/* <CosmosText
					appearance="light"
					size="x-small"
					kind="subtle">
					{email}
				</CosmosText> */}

				{redeemed && (
					<CosmosText
						appearance="light"
						size="x-small">
						Gift redeemed, {moment(redeemedAt).format("dddd HH:mm:ss")}
					</CosmosText>
				)}
				{tour_start &&
					tour_starts.map((tour, index) => (
						<CosmosText
							key={index}
							appearance="light"
							size="x-small">
							{tour_names[index]} tour w/ {tour_guides[index]}, {moment(tour_starts[index]).format("dddd HH:mm")}
						</CosmosText>
					))}

				{!redeemed && checked_in != null && (
					<CosmosText
						appearance="light"
						size="x-small">
						{pin}
					</CosmosText>
				)}
			</div>

			{check_in_available && (
				<div className="guest-row-checkin">
					<div className="guest-row-checked">
						<CosmosCheckbox
							name={id}
							appearance="light"
							checked={checked_in != null ? true : null}
							disabled={checked_in != null}
							onInputchange={({ detail }) => toggleCheckIn(id, detail.checked, false)}>
							{!loading && <>{checked_in != null ? "Checked in" : "Check in"}</>}
							{loading && (
								<Loading
									active={loading}
									label="Processing..."
								/>
							)}
						</CosmosCheckbox>
						{checked_in != null && (
							<CosmosText
								appearance="light"
								size="x-small"
								kind="subtle">
								{moment(checked_in).format("DD/MM/YY HH:mm")}
							</CosmosText>
						)}
					</div>
					<CosmosButton
						className="guest-row-edit"
						size="small"
						shape="square"
						kind="primary"
						onClick={editGuest}>
						<CosmosIconPen />
					</CosmosButton>
				</div>
			)}

			{!check_in_available && (
				<div className="guest-row-delete">
					<CosmosButton
						className="guest-row-edit"
						size="small"
						shape="square"
						kind="secondary"
						onClick={editGuest}>
						<CosmosIconPen />
					</CosmosButton>
					<CosmosButton
						size="small"
						shape="square"
						onClick={() => deleteFromEvent()}
						busy={deleting}>
						<CosmosIconDelete />
					</CosmosButton>
				</div>
			)}
		</div>
	)
}
